module.exports = __webpack_public_path__ + "img/search.73da718d.svg";